
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("2TweP", function(module, exports) {
/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");


var $1KmJq = parcelRequire("1KmJq");


var $lGgRw = parcelRequire("lGgRw");


var $inPa6 = parcelRequire("inPa6");


var $7aRa9 = parcelRequire("7aRa9");


var $3jwuS = parcelRequire("3jwuS");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $9wGTI = parcelRequire("9wGTI");


var $86okN = parcelRequire("86okN");


var $Uu0Pb = parcelRequire("Uu0Pb");


var $8miSe = parcelRequire("8miSe");


var $3lWl0 = parcelRequire("3lWl0");

/* ContentStateButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $gMc0m = parcelRequire("gMc0m");


var $gmMgo = parcelRequire("gmMgo");

var $8C5kA = parcelRequire("8C5kA");


var $ghftu = parcelRequire("ghftu");


var $eEA8O = parcelRequire("eEA8O");


var $1qfLF = parcelRequire("1qfLF");


var $g5gZt = parcelRequire("g5gZt");


var $6DSrS = parcelRequire("6DSrS");


var $6fnsQ = parcelRequire("6fnsQ");


var $3gadb = parcelRequire("3gadb");


var $6f0Oj = parcelRequire("6f0Oj");

var $dcJ7R = parcelRequire("dcJ7R");

var $ecnYn = parcelRequire("ecnYn");











var $iNJwL = parcelRequire("iNJwL");


var $4S6vT = parcelRequire("4S6vT");

/* eslint-disable check-file/filename-blocklist */ 
var $cgtv4 = parcelRequire("cgtv4");

const $adbf40b583ec3a51$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    statusLabel: {
        id: "content-state.add-status.floating-toolbar",
        defaultMessage: "Status"
    },
    changeStatus: {
        id: "content-state.change-status",
        defaultMessage: "Change status"
    },
    setPageStatus: {
        id: "content-state.set-page-status",
        defaultMessage: "Set status"
    },
    setBlogStatus: {
        id: "content-state.set-blog-status",
        defaultMessage: "Set blog post status"
    },
    addCustomStatus: {
        id: "content-state.add-custom-status",
        defaultMessage: "Add custom status"
    },
    custom: {
        id: "content-state.custom",
        defaultMessage: "Custom"
    },
    suggested: {
        id: "content-state.suggested",
        defaultMessage: "Suggested"
    },
    save: {
        id: "content-state.save",
        defaultMessage: "Save"
    },
    cancel: {
        id: "content-state.cancel",
        defaultMessage: "Cancel"
    },
    remove: {
        id: "content-state.remove",
        defaultMessage: "Remove"
    },
    showMoreStatuses: {
        id: "content-state.show.more.statuses",
        defaultMessage: "Show more statuses"
    },
    maxLengthEditor: {
        id: "content-state.max.length.editor.creation",
        defaultMessage: "Max length of 20"
    },
    featureDisabled: {
        id: "content-state.feature.disabled.message",
        defaultMessage: "The content status feature is not enabled in this space."
    },
    errorFlagTitle: {
        id: "content-state.error.flag.title",
        defaultMessage: "We can\u2019t set your status"
    },
    errorFlagBody: {
        id: "content-state.error.flag.body",
        defaultMessage: "Refresh and try again."
    },
    noneText: {
        id: "content-state.none.text",
        defaultMessage: "None"
    },
    colorOptionAriaLabel: {
        id: "content-state.color-option.aria-label",
        defaultMessage: "{colorName} color option"
    },
    colorPickerButtonAriaLabel: {
        id: "content-state.color-picker-button.aria-label",
        defaultMessage: "Color picker button"
    },
    removeButtonAriaLabel: {
        id: "content-state.remove-button.aria-label",
        defaultMessage: "Remove"
    }
});



var $3qCob = parcelRequire("3qCob");

const $32fca6e0bfcfd80d$var$contentStateNameStyles = (0, $ecnYn.xcss)({
    marginLeft: 'space.025',
    marginRight: 'space.025',
    marginTop: 'space.0',
    marginBottom: 'space.0'
});
const $32fca6e0bfcfd80d$var$subtleContentStateNameStyles = (0, $ecnYn.xcss)({
    font: 'font.body.small',
    color: 'color.text.subtle'
});
const $32fca6e0bfcfd80d$var$detailPanelContentStateNameStyles = (0, $ecnYn.xcss)({
    font: 'font.body',
    textOverflow: 'ellipsis',
    overflowX: 'hidden',
    whiteSpace: 'nowrap'
});
const $32fca6e0bfcfd80d$var$chevronDownIconWrapperStyles = (0, $ecnYn.xcss)({
    marginRight: 'space.negative.050'
});
const $32fca6e0bfcfd80d$var$determineSecondarySSRHex = (primaryColor)=>{
    const upperCasePrimaryColor = primaryColor?.toUpperCase(); // need toUpper since color we get from BE is lowercase
    switch(upperCasePrimaryColor){
        case 0, $6fnsQ.B200:
            return '#e9f2ff';
        case 0, $6fnsQ.G200:
            return '#dcfff1';
        case 0, $6fnsQ.Y200:
            return '#fff7d6';
        case 0, $6fnsQ.P200:
            return '#f3f0ff';
        case 0, $6fnsQ.R200:
            return '#ffeceb';
        default:
            return '#e9f2ff';
    }
};
const $32fca6e0bfcfd80d$var$getContentStateButtonBackgroundColor = (isWarning, isSelected, isHovered, color, hoverColor, isPressed)=>{
    if (isWarning) // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    return Boolean(undefined) ? '#ffeceb' : (0, $Uu0Pb.SECONDARY_COLORS).RED;
    if (isSelected) return color;
    if (isPressed) return "var(--ds-background-neutral-subtle-pressed, #0B120E24)";
    return isHovered ? hoverColor : color;
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $32fca6e0bfcfd80d$var$HasContentStateButton = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isDetailsPanel: isDetailsPanel, isSubtle: isSubtle, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2rkofajl _19itglyw _1e0c1txw _4cvr1h6o _1bah1yb4 _80omtlke _syazi7uo _k48p1wq8 _12ji1v1w _j5dh13gf _1j5515iw _cun9by5v",
            __cmplp.isDetailsPanel ? "_4t3i1tcg" : "_4t3izwfg",
            __cmplp.isDetailsPanel ? "_19bv1b66" : !__cmplp.isSubtle ? "_19bv12x7" : "_19bvze3t",
            __cmplp.isDetailsPanel ? "_u5f3v77o" : !__cmplp.isSubtle ? "_u5f312x7" : "_u5f3v77o",
            __cmplp.className
        ])
    });
});
const $32fca6e0bfcfd80d$var$ContentStateButtonBase = ({ triggerProps: triggerProps, togglePopup: togglePopup, contentState: contentState, isSelected: isSelected, isWarning: isWarning, userOffline: userOffline, contentStateButtonRef: contentStateButtonRef, floatingToolbarButtonStyle: floatingToolbarButtonStyle, appearance: appearance, primaryColor: primaryColor, secondaryColor: secondaryColor, hoverColor: hoverColor, showChevron: showChevron, colorAppearance: colorAppearance, tooltipContent: tooltipContent, isDetailsPanel: isDetailsPanel })=>{
    const intl = (0, $8C5kA.default)();
    const [isHovered, setIsHovered] = (0, $42omo.useState)(false);
    const [isPressed, setIsPressed] = (0, $42omo.useState)(false);
    if (!contentState) return null;
    const isContentStateSelectorDisabled = contentState.isCallerPermitted === false || userOffline;
    const buttonStyles = {
        ...floatingToolbarButtonStyle,
        backgroundColor: $32fca6e0bfcfd80d$var$getContentStateButtonBackgroundColor(isWarning, isSelected, isHovered, secondaryColor, hoverColor, isPressed)
    };
    return(//@ts-ignore
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ref: contentStateButtonRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: intl.formatMessage(tooltipContent),
        position: "bottom"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($32fca6e0bfcfd80d$var$HasContentStateButton, {
        ...triggerProps,
        appearance: appearance,
        style: buttonStyles,
        onClick: togglePopup,
        isSelected: isSelected,
        disabled: isContentStateSelectorDisabled,
        isWarning: isWarning,
        color: secondaryColor,
        onMouseEnter: ()=>setIsHovered(true),
        onMouseLeave: ()=>setIsHovered(false),
        onMouseDown: ()=>setIsPressed(true),
        onMouseUp: ()=>setIsPressed(false),
        isSubtle: appearance === 'subtle',
        isDetailsPanel: isDetailsPanel,
        "data-testid": "content-state-trigger",
        type: "button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4S6vT.ContentStateColor), {
        dataTestId: "button-color-icon",
        appearance: colorAppearance,
        color: primaryColor,
        restrictionLevel: contentState.restrictionLevel,
        isWarning: isWarning
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: [
            $32fca6e0bfcfd80d$var$contentStateNameStyles,
            appearance === 'subtle' && $32fca6e0bfcfd80d$var$subtleContentStateNameStyles,
            isDetailsPanel && $32fca6e0bfcfd80d$var$detailPanelContentStateNameStyles
        ],
        testId: "content-state-name"
    }, contentState.name), showChevron && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $32fca6e0bfcfd80d$var$chevronDownIconWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
        color: "currentColor",
        spacing: "compact",
        label: intl.formatMessage((0, $adbf40b583ec3a51$export$a7357cdd1f0b0168).showMoreStatuses),
        testId: "content-state-chevron-down-icon",
        size: "small"
    }))))));
};
const $32fca6e0bfcfd80d$var$ContentStateButtonComponent = ({ triggerProps: triggerProps, togglePopup: togglePopup, contentState: contentState, isSelected: isSelected, isWarning: isWarning, userOffline: userOffline, contentStateButtonRef: contentStateButtonRef, intl: { formatMessage: formatMessage }, floatingToolbarButtonStyle: floatingToolbarButtonStyle, renderPlusButtonEmptyState: renderPlusButtonEmptyState = false, isDetailsPanel: isDetailsPanel = false })=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const getSecondaryColor = ({ primaryColor: primaryColor, isNeutralBackground: isNeutralBackground })=>{
        if (isNeutralBackground) // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        return "var(--ds-elevation-surface-current, #FFFFFF)";
        else // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        return (0, $3qCob.determineSecondaryColor)(primaryColor);
    };
    const getButtonProps = (editorContentState)=>{
        const primaryColor = editorContentState.color;
        const isVerifiedContentState = editorContentState?.restrictionLevel === 'PAGE_OWNER' && editorContentState.name === 'Verified';
        const shouldUseNewEditorBylineButtonStyleProps = !isDetailsPanel && (isLivePage || (0, $9wGTI.fg)('cc_page_experiences_new_editor_byline'));
        if (shouldUseNewEditorBylineButtonStyleProps) return {
            appearance: 'subtle',
            primaryColor: primaryColor,
            secondaryColor: getSecondaryColor({
                primaryColor: primaryColor,
                isNeutralBackground: true
            }),
            hoverColor: "var(--ds-surface-hovered, #F0F1F2)",
            showChevron: false,
            // The verified content state for the new live page byline is special in that due to having a checkmark in it, a larger styling is required over the smaller subtle style
            colorAppearance: isVerifiedContentState ? 'contentStateButton' : 'subtleContentStateButton'
        };
        const secondaryColor = getSecondaryColor({
            primaryColor: primaryColor,
            isNeutralBackground: isDetailsPanel
        });
        const hoverColor = isDetailsPanel ? "var(--ds-surface-hovered, #F0F1F2)" : (0, $3qCob.determineHoverColor)(secondaryColor); // (Make sure that the colorAppearance is set to the same value as used in the details panel's
        //  read-only version found in next/packages/details-panel/src/components/StatusRow.tsx)
        const colorAppearance = isDetailsPanel ? 'rendererContentState' : 'contentStateButton';
        return {
            appearance: 'default',
            primaryColor: primaryColor,
            secondaryColor: secondaryColor,
            hoverColor: hoverColor,
            showChevron: !isDetailsPanel,
            colorAppearance: colorAppearance
        };
    };
    if (contentState) {
        const tooltipContent = contentState.restrictionLevel === 'PAGE_OWNER' ? (0, $iNJwL.sharedi18n).verifiedRestricted : (0, $adbf40b583ec3a51$export$a7357cdd1f0b0168).changeStatus;
        const buttonProps = getButtonProps(contentState);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
            space: "space.0"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($32fca6e0bfcfd80d$var$ContentStateButtonBase, {
            triggerProps: triggerProps,
            togglePopup: togglePopup,
            contentState: contentState,
            isSelected: isSelected,
            isWarning: isWarning,
            userOffline: userOffline,
            contentStateButtonRef: contentStateButtonRef,
            floatingToolbarButtonStyle: floatingToolbarButtonStyle,
            tooltipContent: tooltipContent,
            isDetailsPanel: isDetailsPanel,
            ...buttonProps
        }));
    } // No content state case, but when we want it to render a + icon instead (for details panel)
    if (renderPlusButtonEmptyState) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        ...triggerProps,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($g5gZt))),
        appearance: "subtle",
        label: formatMessage((0, $adbf40b583ec3a51$export$a7357cdd1f0b0168).statusLabel),
        onClick: togglePopup,
        testId: "content-state-empty-state-add-icon"
    });
     // No content state case
    return(// @ts-ignore
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ref: contentStateButtonRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        ...triggerProps,
        appearance: "subtle" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        ,
        style: floatingToolbarButtonStyle || {},
        onClick: togglePopup,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6DSrS))), {
            label: "",
            testId: "content-state-task-icon"
        }),
        isSelected: isSelected,
        spacing: "compact",
        testId: "content-state-trigger",
        isDisabled: userOffline
    }, formatMessage((0, $adbf40b583ec3a51$export$a7357cdd1f0b0168).statusLabel)))));
};
const $32fca6e0bfcfd80d$export$ee3b73f13be68d6d = (0, $gmMgo.default)($32fca6e0bfcfd80d$var$ContentStateButtonComponent);


/* ContentStateMenu.tsx generated by @compiled/babel-plugin v0.36.1 */ 









var $7hXDW = parcelRequire("7hXDW");

var $8ccd225f267efb0e$exports = {};
$8ccd225f267efb0e$exports = new URL("GenericError.42a632b0.svg", import.meta.url).toString();


/* ContentStateForm.tsx generated by @compiled/babel-plugin v0.36.1 */ 














var $fzqvY = parcelRequire("fzqvY");







/* ColorPickerButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 





var $7sObp = parcelRequire("7sObp");
















var $cvXh8 = parcelRequire("cvXh8");











// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $99a97a10d1a2aa69$var$SelectedColor = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isOpen: isOpen, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1odflos": (0, $7sObp.default)(__cmplp.isOpen ? "var(--ds-border-inverse, #FFFFFF)" : __cmplp.color ? __cmplp.color : "var(--ds-border-accent-gray, #7D818A)"),
            "--_xexnhp": (0, $7sObp.default)(__cmplp.color)
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19itmgv6 _2rko1rr0 _1bsb7vkz _4t3i7vkz _2hwx1i6y _18u0v77o _bfhk1cj8",
            __cmplp.className
        ])
    });
});
const $99a97a10d1a2aa69$var$ColorOption = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_xexnhp": (0, $7sObp.default)(__cmplp.color)
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _19it1ps9 _2rko1rr0 _1bsbgktf _4t3igktf _1e0c1txw _4cvr1h6o _1bah1h6o _bfhk1cj8 _12jia755 _80omtlke",
            __cmplp.className
        ])
    });
});
const $99a97a10d1a2aa69$var$ColorOptionWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_80omtlke _16jlkb7n _1e0c1txw _4cvr1h6o _1bah1h6o _ukjc98my",
            __cmplp.className
        ])
    });
});
const $99a97a10d1a2aa69$var$DropDownContentWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _1bahitcz _4cvr1fhb _1bsb10bg _4t3i1ul9",
            __cmplp.className
        ])
    });
});
const $99a97a10d1a2aa69$var$ButtonIconsWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $99a97a10d1a2aa69$var$chevronDownIconWrapperStyles = (0, $ecnYn.xcss)({
    marginRight: 'space.negative.075'
});
const $99a97a10d1a2aa69$export$13cf15360203042f = ({ selectedColor: selectedColor, onSelectColor: onSelectColor, isOpen: isOpen, onClose: onClose, onColorPickerToggle: onColorPickerToggle, userOffline: userOffline, colorPickerComponentRef: colorPickerComponentRef })=>{
    const intl = (0, $8C5kA.default)();
    const colorsArray = [
        (0, $Uu0Pb.PRIMARY_COLORS).BLUE,
        (0, $Uu0Pb.PRIMARY_COLORS).GREEN,
        (0, $Uu0Pb.PRIMARY_COLORS).YELLOW,
        (0, $Uu0Pb.PRIMARY_COLORS).RED,
        (0, $Uu0Pb.PRIMARY_COLORS).PURPLE
    ];
    const statusColors = colorsArray.map((color)=>{
        const isSelected = selectedColor === color;
        const colorName = (0, $8miSe.colorCodeToColorName)(color);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($99a97a10d1a2aa69$var$ColorOptionWrapper, {
            onClick: ()=>onSelectColor(color),
            key: `${color}-option`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($99a97a10d1a2aa69$var$ColorOption, {
            color: color,
            "data-testid": `${(0, $8miSe.tokenToHex)(color)}-option`,
            "aria-label": intl.formatMessage((0, $adbf40b583ec3a51$export$a7357cdd1f0b0168).colorOptionAriaLabel, {
                colorName: colorName
            })
        }, isSelected && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cvXh8))), {
            label: "selected",
            color: "var(--ds-icon-inverse, #FFFFFF)"
        })));
    });
    (0, $42omo.useEffect)(()=>{
        // Focus color picker button after its poppup closes since the modal loses focus when the color popup is closed.
        // Had to use an id instead of ref to keep track of the button since a ref interferes with the trigger button ref
        // the popup component uses.
        const colorPickerButton = document.getElementById('content-state-color-picker-button');
        if (!isOpen && colorPickerButton) // using a setTimeout since state change/re-render is interfering with timing of things and timeout will help force
        // the focus to happen after the re-render https://salesforce.stackexchange.com/a/366973
        setTimeout(()=>{
            colorPickerButton.focus();
        }, 0);
    }, [
        isOpen
    ]);
    // TODO(brizvash): fix incompatible csstype of emotion and compiled
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.default), {
        isOpen: isOpen,
        onClose: onClose,
        testId: "color-picker-popup",
        placement: "bottom-start",
        zIndex: 700,
        shouldRenderToParent: true,
        trigger: ({ ...buttonProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
                ...buttonProps,
                id: "content-state-color-picker-button",
                testId: "color-picker-popup-trigger",
                isSelected: isOpen,
                isDisabled: userOffline,
                onClick: onColorPickerToggle,
                "aria-label": intl.formatMessage((0, $adbf40b583ec3a51$export$a7357cdd1f0b0168).colorPickerButtonAriaLabel),
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($99a97a10d1a2aa69$var$ButtonIconsWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($99a97a10d1a2aa69$var$SelectedColor, {
                    color: selectedColor || undefined,
                    isOpen: isOpen,
                    "data-testid": "selected-color"
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                    xcss: $99a97a10d1a2aa69$var$chevronDownIconWrapperStyles
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                    color: "currentColor",
                    spacing: "spacious",
                    label: "",
                    size: "small"
                })))
            }),
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($99a97a10d1a2aa69$var$DropDownContentWrapper, {
                ref: colorPickerComponentRef
            }, statusColors)
    });
};










var $4noo5 = parcelRequire("4noo5");


var $gQhRa = parcelRequire("gQhRa");

var $fb3kw = parcelRequire("fb3kw");





const $c3e1925399b17e8a$var$ContentStateTextFieldComponent = ({ onFocusTextField: onFocusTextField, showFormFooter: showFormFooter, userOffline: userOffline, intl: { formatMessage: formatMessage } })=>{
    const checkForTab = (0, $42omo.useCallback)((event)=>{
        // if user didn't press tab, means they want to type on the textfield and not tab to next element
        if (event.key !== 'Tab') onFocusTextField();
    }, [
        onFocusTextField
    ]);
    const validateName = (value)=>{
        if (!value) return 'REQUIRED'; // Name input is required
        return undefined;
    };
    return showFormFooter ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fb3kw.default), {
        name: "name",
        validate: validateName
    }, ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4noo5.default), {
            ...fieldProps,
            placeholder: formatMessage((0, $adbf40b583ec3a51$export$a7357cdd1f0b0168).addCustomStatus),
            isCompact: true,
            autoComplete: "off",
            testId: "name-input",
            maxLength: 20,
            isDisabled: userOffline
        }), error === 'REQUIRED' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gQhRa.ErrorMessage), null, formatMessage((0, $iNJwL.sharedi18n).requiredErrorMessage)), !error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gQhRa.HelperMessage), null, formatMessage((0, $adbf40b583ec3a51$export$a7357cdd1f0b0168).maxLengthEditor)))) : // Dummy name input is rendered in place of actual name input when user is not creating page status
    // in order to clear validation errors and input value since the current atlaskit field API doesnt
    // provide such flexibility
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fb3kw.default), {
        name: "dummy-name"
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4noo5.default), {
            ...fieldProps,
            onKeyDown: checkForTab,
            onMouseDown: onFocusTextField,
            isDisabled: userOffline,
            placeholder: formatMessage((0, $adbf40b583ec3a51$export$a7357cdd1f0b0168).addCustomStatus),
            isCompact: true,
            value: "",
            testId: "dummy-name-input"
        }));
};
const $c3e1925399b17e8a$export$c3a18725b7210022 = (0, $gmMgo.default)($c3e1925399b17e8a$var$ContentStateTextFieldComponent);


const $45bd28dec8e86674$var$TextFieldWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1o8l _1bsb15w3",
            __cmplp.className
        ])
    });
});
const $45bd28dec8e86674$var$ColorPickerButtonWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2hwx12x7 _1e0c1o8l _s7n4jp4b _19pku2gc",
            __cmplp.className
        ])
    });
});
const $45bd28dec8e86674$var$FormFooterWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isVisible: isVisible, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1bahesu3 _19pkutpp _p7u6u2gc",
            __cmplp.isVisible ? "_1e0c1txw" : "_1e0cglyw",
            __cmplp.className
        ])
    });
});
const $45bd28dec8e86674$var$ColorAndInputWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
});
const $45bd28dec8e86674$var$ContentStateFormComponent = (0, $7aRa9.withFlags)(({ onSubmit: onSubmit, onCancel: onCancel, showFormFooter: showFormFooter, selectedColor: selectedColor, onSelectColor: onSelectColor, isColorPickerOpen: isColorPickerOpen, onColorPickerToggle: onColorPickerToggle, onColorPickerClose: onColorPickerClose, onFocusTextField: onFocusTextField, userOffline: userOffline, colorPickerComponentRef: colorPickerComponentRef, flags: flags, intl: { formatMessage: formatMessage } })=>{
    const handleSubmit = (data)=>{
        const trimmedName = data.name.replace(/\s+/g, ' ').trim();
        if (trimmedName) onSubmit(trimmedName);
        else // show warning flag if user entered all whitespace
        flags.showWarningFlag({
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $iNJwL.sharedi18n).emptyStatusFlagTitle),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $iNJwL.sharedi18n).emptyStatusFlagDescription)
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fzqvY.default), {
        onSubmit: handleSubmit,
        testId: "content-state-form"
    }, ({ formProps: formProps })=>// eslint-disable-next-line @atlassian/a11y/no-noninteractive-element-interactions
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("form", {
            ref: formProps.ref,
            onKeyDown: formProps.onKeyDown
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($45bd28dec8e86674$var$ColorAndInputWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($45bd28dec8e86674$var$ColorPickerButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $99a97a10d1a2aa69$export$13cf15360203042f), {
            onColorPickerToggle: onColorPickerToggle,
            selectedColor: selectedColor,
            onSelectColor: onSelectColor,
            isOpen: isColorPickerOpen,
            onClose: onColorPickerClose,
            userOffline: userOffline,
            colorPickerComponentRef: colorPickerComponentRef
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($45bd28dec8e86674$var$TextFieldWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c3e1925399b17e8a$export$c3a18725b7210022), {
            onFocusTextField: onFocusTextField,
            showFormFooter: showFormFooter,
            userOffline: userOffline
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($45bd28dec8e86674$var$FormFooterWrapper, {
            isVisible: showFormFooter,
            "data-testid": "content-state-form-footer"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
            onClick: onCancel,
            spacing: "compact",
            appearance: "subtle",
            testId: "content-state-cancel"
        }, formatMessage((0, $adbf40b583ec3a51$export$a7357cdd1f0b0168).cancel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
            testId: "content-state-submit",
            type: "submit",
            spacing: "compact",
            appearance: "primary",
            onClick: formProps.onSubmit
        }, formatMessage((0, $adbf40b583ec3a51$export$a7357cdd1f0b0168).save)))));
});
const $45bd28dec8e86674$export$2ae5c8bd8129bb8e = /*#__PURE__*/ (0, $42omo.memo)((0, $gmMgo.default)($45bd28dec8e86674$var$ContentStateFormComponent));


/* ContentStateGroup.tsx generated by @compiled/babel-plugin v0.36.1 */ /**
 * @graphql cc
 */ 











































/* ContentState.tsx generated by @compiled/babel-plugin v0.36.1 */ 













const $0de1820bd94dcfc9$var$ContentStateWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _11c82smr _19itglyw _1e0c1txw _4cvr1h6o _80omtlke _4t3i14no _1bsb1osq _bfhksm61 _syazi7uo _12jia755 _j5dh13gf _1j5515iw _cun91j28 _irr3i8nm",
            __cmplp.className
        ])
    });
});
const $0de1820bd94dcfc9$var$contentStateNameStyles = (0, $ecnYn.xcss)({
    textOverflow: 'ellipsis',
    overflowX: 'hidden',
    whiteSpace: 'nowrap'
});
const $0de1820bd94dcfc9$export$96e9e87da55ad40c = ({ contentState: contentState, onClick: onClick, userOffline: userOffline })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0de1820bd94dcfc9$var$ContentStateWrapper, {
        "data-testid": "content-state",
        onClick: onClick,
        disabled: userOffline
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4S6vT.ContentStateColor), {
        dataTestId: "content-state-color",
        appearance: "editorContentState",
        color: contentState.color,
        restrictionLevel: contentState.restrictionLevel
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: [
            $0de1820bd94dcfc9$var$contentStateNameStyles
        ]
    }, contentState.name));
};



/* eslint-disable check-file/filename-blocklist */ const $c169b00c0122f30f$export$fa2d28b3b2819e2d = 'custom';
const $c169b00c0122f30f$export$b3c3dee917fc137d = 'suggested';





const $742e27b1b03e5e97$var$GroupLabel = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c82smr _otyrutpp _syazazsu _k48p1wq8 _18u01ejb",
            __cmplp.className
        ])
    });
});
const $742e27b1b03e5e97$var$ContentStateListWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "ul", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_18s8ze3t _1yt4ze3t _2mzuglyw",
            __cmplp.className
        ])
    });
});
const $742e27b1b03e5e97$export$b5eb02bd35e29271 = ({ contentId: contentId, contentStateState: contentStateState, groupIsEnabled: groupIsEnabled, groupLabel: groupLabel, contentStates: contentStates, flags: flags, userOffline: userOffline, intl: { formatMessage: formatMessage }, onUpdateSuccess: onUpdateSuccess, setIsContentStateMenuOpen: setIsContentStateMenuOpen })=>{
    // Need these refs to store original content states/array
    // in the case of an error (ex: user picks a state but somehow admin turned off at the same time) we need to
    // show the original values since we set it right after we mutate and there's no way to check if there are any
    // errors until after we mutate
    const originalContentState = (0, $42omo.useRef)(contentStateState.state.contentState);
    const originalCustomStatesArray = (0, $42omo.useRef)(contentStateState.state.customStatesArray);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [shouldSetAutomationFlag, setShouldSetAutomationFlag] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        if (!(0, $17wUi.confluenceLocalStorageInstance).getItemAsBoolean((0, $1UApO.keys).AUTOMATION_DISCOVER_SET_CONTENT_STATE) && (0, $9wGTI.fg)('cc_a4c_smart_button_changeboarding')) setShouldSetAutomationFlag(true);
    }, []);
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const [setContentStateMutation] = (0, $1KmJq.useMutation)((0, $eSUdr.default)`mutation ContentStateGroupSetContentStateMutation($contentId:ID!$contentStateInput:ContentStateInput!){setContentState(contentId:$contentId contentState:$contentStateInput){name color id restrictionLevel}}`, {
        onError: ()=>{
            // rollback to originals since they got updated and show error flag
            contentStateState.setContentState(originalContentState.current);
            contentStateState.setCustomStatesArray(originalCustomStatesArray.current);
            flags.showErrorFlag({
                id: 'content-state-error-flag',
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $adbf40b583ec3a51$export$a7357cdd1f0b0168).errorFlagTitle),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $adbf40b583ec3a51$export$a7357cdd1f0b0168).errorFlagBody)
            });
            createAnalyticsEvent({
                type: 'sendScreenEvent',
                data: {
                    objectId: contentId,
                    name: 'contentStateErrorFlag',
                    attributes: {
                        isLivePage: isLivePage
                    }
                }
            }).fire();
        },
        onCompleted: ()=>{
            // If a mutation was successfully completed, save the state/array in case an error occurs and we need to
            // rollback to these values
            originalContentState.current = contentStateState.state.contentState;
            originalCustomStatesArray.current = contentStateState.state.customStatesArray;
            contentStateState.setIsUpdating(false);
            onUpdateSuccess?.();
        },
        // Need to refetch since our cache isn't updating correctly - temporary solution until BE fixes
        refetchQueries: ()=>[
                {
                    query: (0, $86okN.toDocumentNode)((0, $3lWl0.default)),
                    variables: {
                        contentId: contentId,
                        isDraft: !isLivePage
                    }
                }
            ]
    });
    const handleClick = (0, $42omo.useCallback)((newContentState, label, index)=>{
        contentStateState.setIsUpdating(true);
        setContentStateMutation({
            variables: {
                contentId: contentId,
                contentStateInput: {
                    color: (0, $8miSe.tokenToHex)(newContentState.color),
                    name: newContentState.name,
                    id: newContentState.id // TODO fix type
                }
            }
        });
        contentStateState.setContentState(newContentState);
        setIsContentStateMenuOpen(false); // if label selected was a custom one, updated the custom list to add the selected label on top
        if (label === (0, $c169b00c0122f30f$export$fa2d28b3b2819e2d)) {
            const newCustomStatesArray = (0, $3qCob.createNewCustomStatesArrayWhenExistingCustomSelected)(contentStateState.state.customStatesArray, newContentState, index);
            contentStateState.setCustomStatesArray(newCustomStatesArray);
        }
        if (shouldSetAutomationFlag && (0, $9wGTI.fg)('cc_a4c_smart_button_changeboarding')) {
            // This flag is used in AutomationMenuButtonWithSmartButtonSpotlight
            // It will check this flag to determine if it should show the spotlight
            (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).AUTOMATION_DISCOVER_SET_CONTENT_STATE, true);
            setShouldSetAutomationFlag(false);
        }
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                objectId: contentId,
                actionSubjectId: 'editorContentStateAdded',
                source: 'editorContentState',
                attributes: {
                    type: label,
                    // "custom" or "suggested"
                    color: (0, $8miSe.colorCodeToColorName)(newContentState.color.toUpperCase()),
                    restrictionLevel: newContentState.restrictionLevel?.toUpperCase(),
                    uiLocation: 'pageTitleSection',
                    isLivePage: isLivePage
                }
            }
        }).fire();
    }, [
        contentId,
        contentStateState,
        createAnalyticsEvent,
        setContentStateMutation,
        setIsContentStateMenuOpen,
        isLivePage,
        shouldSetAutomationFlag
    ]);
    const contentStateList = contentStates.map((contentState, index)=>{
        if (contentState) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $0de1820bd94dcfc9$export$96e9e87da55ad40c), {
            contentState: contentState,
            userOffline: userOffline,
            onClick: ()=>handleClick(contentState, groupLabel, index),
            key: `${groupLabel}-content-state-${index}`
        });
    });
    return groupIsEnabled && contentStates.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": `${groupLabel.toLowerCase()}-content-states`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($742e27b1b03e5e97$var$GroupLabel, {
        "aria-label": groupLabel
    }, groupLabel === (0, $c169b00c0122f30f$export$fa2d28b3b2819e2d) ? formatMessage((0, $adbf40b583ec3a51$export$a7357cdd1f0b0168).custom) : formatMessage((0, $adbf40b583ec3a51$export$a7357cdd1f0b0168).suggested)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($742e27b1b03e5e97$var$ContentStateListWrapper, {
        "aria-label": groupLabel
    }, contentStateList)) : null;
};
const $742e27b1b03e5e97$export$710aa0e581cfaff9 = (0, $gmMgo.default)((0, $7aRa9.withFlags)($742e27b1b03e5e97$export$b5eb02bd35e29271));


/* RemoveButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 











var $gKvd9 = parcelRequire("gKvd9");








const $a14c780b3cacba28$var$RemoveButtonWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1eacras": (0, $7sObp.default)((0, $Uu0Pb.PRIMARY_COLORS).RED)
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19itglyw _2rkofajl _1bsb1tcg _4t3i1tcg _1e0c1txw _1bah1h6o _4cvr1h6o _80omtlke _12ji15c5 _bfhk1j28 _syazi7uo _j5dh13gf _1j5515iw _vbqb1gmx _cun91j28 _jomri8nm _f8pj13b0 _irr3i8nm _30l313b0 _1di6i8nm _9h8h13b0",
            __cmplp.className
        ])
    });
});
const $a14c780b3cacba28$var$RemoveButtonPlaceholder = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1bsb1tcg _4t3i1tcg",
            __cmplp.className
        ])
    });
});
const $a14c780b3cacba28$var$RemoveButtonComponent = ({ onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, hasContentState: hasContentState, userOffline: userOffline, intl: { formatMessage: formatMessage } })=>{
    const [isFocused, setIsFocused] = (0, $42omo.useState)(false);
    const handleOnFocus = (0, $42omo.useCallback)(()=>{
        setIsFocused(true);
        onMouseEnter();
    }, [
        onMouseEnter
    ]);
    const handleOnBlur = (0, $42omo.useCallback)(()=>{
        setIsFocused(false);
        onMouseLeave();
    }, [
        onMouseLeave
    ]);
    const handleOnMouseLeave = (0, $42omo.useCallback)(()=>{
        // only call onMouseLeave if we're not focused because we want to keep the buttons red if we are
        if (!isFocused) onMouseLeave();
    }, [
        isFocused,
        onMouseLeave
    ]);
    return hasContentState ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: formatMessage((0, $adbf40b583ec3a51$export$a7357cdd1f0b0168).remove),
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a14c780b3cacba28$var$RemoveButtonWrapper, {
        onClick: onClick,
        "data-testid": "remove-button",
        onMouseEnter: onMouseEnter,
        onMouseLeave: handleOnMouseLeave,
        onFocus: handleOnFocus,
        onBlur: handleOnBlur,
        disabled: userOffline,
        "aria-label": formatMessage((0, $adbf40b583ec3a51$export$a7357cdd1f0b0168).removeButtonAriaLabel)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gKvd9))), {
        color: "currentColor",
        spacing: "spacious",
        label: ""
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a14c780b3cacba28$var$RemoveButtonPlaceholder, {
        "data-testid": "remove-button-placeholder"
    });
};
const $a14c780b3cacba28$export$4e9d5ce1e6c22a94 = (0, $gmMgo.default)($a14c780b3cacba28$var$RemoveButtonComponent);




// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $35470e23ff8dc4a3$var$ContentStateMenuWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt45uws _1bsb1l7m",
            __cmplp.className
        ])
    });
});
const $35470e23ff8dc4a3$var$HeaderWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_18s81lhn _1e0c1txw _1bah1yb4 _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $35470e23ff8dc4a3$var$FormWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_18s81lhn",
            __cmplp.className
        ])
    });
});
const $35470e23ff8dc4a3$var$HorizontalDivider = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_18s8127m _bfhki8nm _4t3it94y _1bsbgx0z",
            __cmplp.className
        ])
    });
});
const $35470e23ff8dc4a3$var$ContentStateGroupsWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_yopyv47k",
            __cmplp.className
        ])
    });
});
const $35470e23ff8dc4a3$var$ContentStateDisabledDiv = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $35470e23ff8dc4a3$var$FeatureDisabledGraphic = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_4t3iymf6 _1bsb12am",
            __cmplp.className
        ])
    });
});
const $35470e23ff8dc4a3$var$FeatureDisabledTextWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_18s8utpp _syaz1gmx _y3gn1h6o",
            __cmplp.className
        ])
    });
});
const $35470e23ff8dc4a3$var$ContentStateMenuComponent = ({ contentId: contentId, contentStateState: contentStateState, contentType: contentType, isContentStateEnabled: isContentStateEnabled, isCustomEnabled: isCustomEnabled, defaultStatesArray: defaultStatesArray, customStatesArray: customStatesArray, isSuggestedEnabled: isSuggestedEnabled, isCreatingContentState: isCreatingContentState, selectedColor: selectedColor, onSelectColor: onSelectColor, isColorPickerOpen: isColorPickerOpen, onColorPickerClose: onColorPickerClose, onColorPickerToggle: onColorPickerToggle, onSubmit: onSubmit, onRemove: onRemove, onCancel: onCancel, onFocusTextField: onFocusTextField, onMouseEnterRemove: onMouseEnterRemove, onMouseLeaveRemove: onMouseLeaveRemove, userOffline: userOffline, onPopupClose: onPopupClose, contentStateButtonRef: contentStateButtonRef, intl: { formatMessage: formatMessage }, onUpdateSuccess: onUpdateSuccess, isContentStateMenuOpen: isContentStateMenuOpen, setIsContentStateMenuOpen: setIsContentStateMenuOpen, updatePopup: updatePopup })=>{
    const menuComponent = (0, $42omo.useRef)(null);
    const colorPickerComponent = (0, $42omo.useRef)(null);
    // If user clicks outside the hover menu, color picker component, or content state button, close the menu.
    const handleClickOutside = (0, $42omo.useCallback)((event)=>{
        if (menuComponent?.current && event.target instanceof Node && !menuComponent?.current?.contains(event.target) && !colorPickerComponent?.current?.contains(event.target) && !contentStateButtonRef?.current?.contains(event.target)) onPopupClose();
    }, [
        onPopupClose,
        contentStateButtonRef
    ]);
    const handleKeydown = (0, $42omo.useCallback)((event)=>{
        // If user hits esc key and the color picked is open, assume they want to close that.
        // Otherwise, close the whole modal.
        if (event.key === 'Escape' && isContentStateMenuOpen) {
            if (isColorPickerOpen) onColorPickerClose();
            else onPopupClose();
        }
    }, [
        isContentStateMenuOpen,
        isColorPickerOpen,
        onColorPickerClose,
        onPopupClose
    ]);
    (0, $42omo.useEffect)(()=>{
        // Something is wrong where atlaskit popup component isn't automatically closing when user hits esc key (I think due to
        // because of nested popups). Therefore, we need to check if user hits escape key to close the popups
        document.addEventListener('keydown', handleKeydown);
        return ()=>{
            document.removeEventListener('keydown', handleKeydown);
        };
    // need to add isColorPickerOpen to dep array since event doesn't get updated state - https://stackoverflow.com/a/53846698
    }, [
        isColorPickerOpen,
        handleKeydown
    ]);
    (0, $42omo.useEffect)(()=>{
        document.addEventListener('mousedown', handleClickOutside);
        return ()=>{
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [
        handleClickOutside
    ]);
    const didRender = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        if (!didRender.current) {
            didRender.current = true;
            return;
        }
        // Reposition popup if content states load in after the popup is opened.
        // Prevents the popup from extending beyond the viewport.
        updatePopup();
    }, [
        defaultStatesArray,
        customStatesArray,
        updatePopup
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($35470e23ff8dc4a3$var$ContentStateMenuWrapper, {
        ref: menuComponent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($35470e23ff8dc4a3$var$HeaderWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7hXDW.default), {
        size: "xsmall",
        as: "h4"
    }, contentType === 'blogpost' ? formatMessage((0, $adbf40b583ec3a51$export$a7357cdd1f0b0168).setBlogStatus) : formatMessage((0, $adbf40b583ec3a51$export$a7357cdd1f0b0168).setPageStatus)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a14c780b3cacba28$export$4e9d5ce1e6c22a94), {
        hasContentState: !!contentStateState.state.contentState,
        onClick: onRemove,
        onMouseEnter: onMouseEnterRemove,
        onMouseLeave: onMouseLeaveRemove,
        userOffline: userOffline
    })), isCustomEnabled && isContentStateEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($35470e23ff8dc4a3$var$FormWrapper, {
        "data-testid": "form-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $45bd28dec8e86674$export$2ae5c8bd8129bb8e), {
        onSubmit: onSubmit,
        onCancel: onCancel,
        showFormFooter: isCreatingContentState,
        selectedColor: selectedColor,
        onSelectColor: onSelectColor,
        isColorPickerOpen: isColorPickerOpen,
        onColorPickerToggle: onColorPickerToggle,
        onColorPickerClose: onColorPickerClose,
        onFocusTextField: onFocusTextField,
        userOffline: userOffline,
        colorPickerComponentRef: colorPickerComponent
    })), isContentStateEnabled ? !isCreatingContentState && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($35470e23ff8dc4a3$var$HorizontalDivider, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($35470e23ff8dc4a3$var$ContentStateGroupsWrapper, {
        "data-testid": "content-state-group"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $742e27b1b03e5e97$export$710aa0e581cfaff9), {
        contentId: contentId,
        contentStateState: contentStateState,
        groupIsEnabled: isCustomEnabled,
        groupLabel: (0, $c169b00c0122f30f$export$fa2d28b3b2819e2d),
        contentStates: customStatesArray,
        userOffline: userOffline,
        onUpdateSuccess: onUpdateSuccess,
        setIsContentStateMenuOpen: setIsContentStateMenuOpen
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $742e27b1b03e5e97$export$710aa0e581cfaff9), {
        contentId: contentId,
        contentStateState: contentStateState,
        groupIsEnabled: isSuggestedEnabled,
        groupLabel: (0, $c169b00c0122f30f$export$b3c3dee917fc137d),
        contentStates: defaultStatesArray,
        userOffline: userOffline,
        onUpdateSuccess: onUpdateSuccess,
        setIsContentStateMenuOpen: setIsContentStateMenuOpen
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($35470e23ff8dc4a3$var$ContentStateDisabledDiv, {
        "data-testid": "content-state-disabled"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($35470e23ff8dc4a3$var$HorizontalDivider, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($35470e23ff8dc4a3$var$FeatureDisabledGraphic, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($8ccd225f267efb0e$exports))),
        alt: "content states disabled graphic"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($35470e23ff8dc4a3$var$FeatureDisabledTextWrapper, {
        "data-testid": "feature-disabled-text"
    }, formatMessage((0, $adbf40b583ec3a51$export$a7357cdd1f0b0168).featureDisabled))));
};
const $35470e23ff8dc4a3$export$d369faa039f625c2 = (0, $gmMgo.default)($35470e23ff8dc4a3$var$ContentStateMenuComponent);






const $1478047e1c32b5f4$export$fd37fef230d4b03a = ({ contentId: contentId, contentType: contentType, contentStateState: contentStateState, userOffline: userOffline, flags: flags, forceContentStatePlacementToTop: forceContentStatePlacementToTop, onUpdateSuccess: onUpdateSuccess, onContentStateMenuToggle: onContentStateMenuToggle, floatingToolbarButtonStyle: floatingToolbarButtonStyle, renderPlusButtonEmptyState: renderPlusButtonEmptyState, isDetailsPanel: isDetailsPanel, onClick: onClick })=>{
    // need this ref to store original content state in case of mutation error and we need to rollback to the original one
    const originalContentState = (0, $42omo.useRef)(contentStateState.state.contentState);
    const contentStateButtonRef = (0, $42omo.useRef)(null);
    const [isCreatingContentState, setIsCreatingContentState] = (0, $42omo.useState)(false);
    const [selectedColor, setSelectedColor] = (0, $42omo.useState)(null);
    const [isColorPickerOpen, setIsColorPickerOpen] = (0, $42omo.useState)(false);
    const [isHoveringRemove, setIsHoveringRemove] = (0, $42omo.useState)(false);
    const [isContentStateMenuOpen, setIsContentStateMenuOpen] = (0, $42omo.useState)(false);
    const setIsContentStateMenuOpenWithListener = (0, $42omo.useCallback)((newValue)=>{
        onContentStateMenuToggle?.(newValue);
        setIsContentStateMenuOpen(newValue);
    }, [
        onContentStateMenuToggle,
        setIsContentStateMenuOpen
    ]);
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [shouldSetAutomationFlag, setShouldSetAutomationFlag] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        if (!(0, $17wUi.confluenceLocalStorageInstance)?.getItemAsBoolean((0, $1UApO.keys).AUTOMATION_DISCOVER_SET_CONTENT_STATE) && (0, $9wGTI.fg)('cc_a4c_smart_button_changeboarding')) setShouldSetAutomationFlag(true);
    }, []);
    const [removeContentStateMutation] = (0, $1KmJq.useMutation)((0, $eSUdr.default)`mutation EditorContentStateComponentRemoveContentStateMutation($contentId:ID!){removeContentState(contentId:$contentId)}`, {
        // Need to refetch since our cache isn't updating correctly - temporary solution until BE fixes
        refetchQueries: ()=>[
                {
                    query: (0, $86okN.toDocumentNode)((0, $3lWl0.default)),
                    variables: {
                        contentId: contentId,
                        isDraft: !isLivePage
                    }
                }
            ],
        onCompleted: ()=>{
            onUpdateSuccess?.();
        }
    });
    const [setContentStateMutation] = (0, $1KmJq.useMutation)((0, $eSUdr.default)`mutation EditorContentStateComponentSetContentStateMutation($contentId:ID!$contentStateInput:ContentStateInput!){setContentState(contentId:$contentId contentState:$contentStateInput){name color id restrictionLevel}}`, {
        onError: ()=>{
            contentStateState.setContentState(originalContentState.current);
            flags.showErrorFlag({
                id: 'content-state-error-flag',
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $adbf40b583ec3a51$export$a7357cdd1f0b0168).errorFlagTitle),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $adbf40b583ec3a51$export$a7357cdd1f0b0168).errorFlagBody)
            });
            createAnalyticsEvent({
                type: 'sendScreenEvent',
                data: {
                    objectId: contentId,
                    name: 'contentStateErrorFlag',
                    attributes: {
                        isLivePage: isLivePage
                    }
                }
            }).fire();
        },
        onCompleted: (data)=>{
            // In this file if this mutation is called, it means a user created a new custom content state. We don't know this new
            // content state's ID since it's newly created so we need to wait on the BE mutation response.
            // Here, we create a new custom states array to add the newly added custom states since that list always has the
            // 3 most recently used states.
            if (data.setContentState) {
                const newCustomStatesArray = (0, $3qCob.createNewCustomStatesArrayWhenNewCustomAdded)(contentStateState.state.customStatesArray, data.setContentState);
                contentStateState.setCustomStatesArray(newCustomStatesArray);
                // @ts-ignore
                originalContentState.current = data.setContentState;
            }
            contentStateState.setIsUpdating(false);
            onUpdateSuccess?.();
        },
        // Need to refetch since our cache isn't updating correctly - temporary solution until BE fixes
        refetchQueries: ()=>[
                {
                    query: (0, $86okN.toDocumentNode)((0, $3lWl0.default)),
                    variables: {
                        contentId: contentId,
                        isDraft: !isLivePage
                    }
                }
            ]
    });
    const handleSelectColor = (0, $42omo.useCallback)((newColor)=>{
        setSelectedColor(newColor);
        setIsColorPickerOpen(false);
        setIsCreatingContentState(true);
    }, []);
    const handleSubmit = (0, $42omo.useCallback)((name)=>{
        if (selectedColor && !(0, $3qCob.isDuplicate)(contentStateState.state.contentState, {
            color: selectedColor.toLowerCase(),
            name: name
        })) {
            const newContentState = {
                color: selectedColor,
                name: name
            };
            contentStateState.setIsUpdating(true);
            setContentStateMutation({
                variables: {
                    contentId: contentId,
                    contentStateInput: {
                        ...newContentState,
                        color: (0, $8miSe.tokenToHex)(selectedColor)
                    }
                }
            });
            contentStateState.setContentState(newContentState);
        }
        if (shouldSetAutomationFlag && (0, $9wGTI.fg)('cc_a4c_smart_button_changeboarding')) {
            // This flag is used in AutomationMenuButtonWithSmartButtonSpotlight
            // It will check this flag to determine if it should show the spotlight
            (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).AUTOMATION_DISCOVER_SET_CONTENT_STATE, true);
            setShouldSetAutomationFlag(false);
        }
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                objectId: contentId,
                actionSubjectId: 'editorContentStateAdded',
                source: 'editorContentState',
                attributes: {
                    type: 'new custom',
                    color: (0, $8miSe.colorCodeToColorName)(selectedColor),
                    // Hard coded since all custom states lack restrictions.
                    restrictionLevel: 'NONE',
                    uiLocation: 'pageTitleSection',
                    isLivePage: isLivePage
                }
            }
        }).fire();
        setIsContentStateMenuOpenWithListener(false);
        setIsCreatingContentState(false);
        setSelectedColor(null);
    }, [
        contentId,
        contentStateState,
        createAnalyticsEvent,
        selectedColor,
        setContentStateMutation,
        setIsContentStateMenuOpenWithListener,
        isLivePage,
        shouldSetAutomationFlag
    ]);
    const handleCancel = (0, $42omo.useCallback)(()=>{
        setSelectedColor(null);
        setIsCreatingContentState(false);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                objectId: contentId,
                actionSubjectId: 'editorContentStateCancel',
                source: 'editorContentState',
                attributes: {
                    isLivePage: isLivePage
                }
            }
        }).fire();
    }, [
        contentId,
        createAnalyticsEvent,
        isLivePage
    ]);
    const handleRemove = (0, $42omo.useCallback)(()=>{
        // check if state exists before mutating since the trash button still shows if the feature is disabled
        // (page might not have a content state)
        if (contentStateState.state.contentState) {
            removeContentStateMutation({
                variables: {
                    contentId: contentId
                }
            });
            setIsCreatingContentState(false);
            setIsHoveringRemove(false);
            contentStateState.setContentState(null);
            setIsContentStateMenuOpenWithListener(false);
        }
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                objectId: contentId,
                actionSubjectId: 'editorContentStateRemoved',
                source: 'editorContentState',
                attributes: {
                    uiLocation: 'pageTitleSection',
                    isLivePage: isLivePage
                }
            }
        }).fire();
    }, [
        contentId,
        contentStateState,
        createAnalyticsEvent,
        removeContentStateMutation,
        setIsCreatingContentState,
        setIsContentStateMenuOpenWithListener,
        isLivePage
    ]);
    const handleFocusTextField = (0, $42omo.useCallback)(()=>{
        if (!isCreatingContentState) {
            setIsCreatingContentState(true);
            // Blue is default color
            setSelectedColor((0, $Uu0Pb.PRIMARY_COLORS).BLUE);
        }
    }, [
        isCreatingContentState
    ]);
    const handleContentStatePopupClose = (0, $42omo.useCallback)(()=>{
        setSelectedColor(null);
        setIsCreatingContentState(false);
        setIsColorPickerOpen(false);
        setIsHoveringRemove(false);
        setIsContentStateMenuOpenWithListener(false);
    }, [
        setIsContentStateMenuOpenWithListener
    ]);
    const handleColorPickerClose = (0, $42omo.useCallback)(()=>{
        setIsColorPickerOpen(false);
    }, []);
    const handleColorPickerToggle = (0, $42omo.useCallback)(()=>{
        setIsColorPickerOpen((prevIsColorPickerOpen)=>!prevIsColorPickerOpen);
    }, []);
    const handleMouseEnterRemove = (0, $42omo.useCallback)(()=>{
        setIsHoveringRemove(true);
    }, []);
    const handleMouseLeaveRemove = (0, $42omo.useCallback)(()=>{
        setIsHoveringRemove(false);
    }, []);
    const handlePopupToggle = (0, $42omo.useCallback)(()=>{
        setIsContentStateMenuOpenWithListener(!isContentStateMenuOpen);
    }, [
        isContentStateMenuOpen,
        setIsContentStateMenuOpenWithListener
    ]);
    const togglePopup = ()=>{
        handlePopupToggle();
        onClick?.();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.default), {
        testId: "content-state-popup",
        isOpen: isContentStateMenuOpen,
        placement: forceContentStatePlacementToTop ? 'top-end' : 'bottom-start',
        zIndex: 700,
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $32fca6e0bfcfd80d$export$ee3b73f13be68d6d), {
                triggerProps: {
                    ...triggerProps
                },
                togglePopup: togglePopup,
                contentState: contentStateState.state.contentState,
                isSelected: isContentStateMenuOpen,
                isWarning: isHoveringRemove,
                userOffline: userOffline,
                contentStateButtonRef: contentStateButtonRef,
                floatingToolbarButtonStyle: floatingToolbarButtonStyle,
                renderPlusButtonEmptyState: renderPlusButtonEmptyState,
                isDetailsPanel: isDetailsPanel
            }),
        content: ({ update: update })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $35470e23ff8dc4a3$export$d369faa039f625c2), {
                contentId: contentId,
                contentStateState: contentStateState,
                contentType: contentType,
                isCustomEnabled: contentStateState.state.isCustomEnabled,
                defaultStatesArray: contentStateState.state.defaultStatesArray || [],
                customStatesArray: contentStateState.state.customStatesArray || [],
                isContentStateEnabled: contentStateState.state.isContentStateEnabled,
                isSuggestedEnabled: contentStateState.state.isSuggestedEnabled,
                isCreatingContentState: isCreatingContentState,
                selectedColor: selectedColor,
                onSelectColor: handleSelectColor,
                isColorPickerOpen: isColorPickerOpen,
                onColorPickerToggle: handleColorPickerToggle,
                onColorPickerClose: handleColorPickerClose,
                onPopupClose: handleContentStatePopupClose,
                onSubmit: handleSubmit,
                onCancel: handleCancel,
                onRemove: handleRemove,
                onFocusTextField: handleFocusTextField,
                onMouseEnterRemove: handleMouseEnterRemove,
                onMouseLeaveRemove: handleMouseLeaveRemove,
                userOffline: userOffline,
                contentStateButtonRef: contentStateButtonRef,
                onUpdateSuccess: onUpdateSuccess,
                isContentStateMenuOpen: isContentStateMenuOpen,
                setIsContentStateMenuOpen: setIsContentStateMenuOpenWithListener,
                updatePopup: update
            })
    });
};
const $1478047e1c32b5f4$export$80f871af2133e26f = (0, $7aRa9.withFlags)($1478047e1c32b5f4$export$fd37fef230d4b03a);
module.exports["EditorContentStateComponentImpl"] = $1478047e1c32b5f4$export$fd37fef230d4b03a;
module.exports["EditorContentStateComponent"] = $1478047e1c32b5f4$export$80f871af2133e26f;

});

parcelRegister("7aRa9", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $T1bCI = parcelRequire("T1bCI");


var $gqqjz = parcelRequire("gqqjz");

function $eb37d7497b3d263d$export$e624a3067d475d88(InnerComponent) {
    var _WithFlags;
    return _WithFlags = class WithFlags extends (0, $42omo.Component) {
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
                to: [
                    (0, $gqqjz.FlagsStateContainer)
                ]
            }, (flags)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(InnerComponent, {
                    ...this.props,
                    flags: flags
                }));
        }
    }, _WithFlags.displayName = `withFlags(${InnerComponent.displayName || InnerComponent.name})`, _WithFlags;
}
module.exports["withFlags"] = $eb37d7497b3d263d$export$e624a3067d475d88;

});

parcelRegister("Uu0Pb", function(module, exports) {
const $1c48b1994652ad1b$export$af156f0af92331bd = {
    BLUE: "var(--ds-background-accent-blue-subtle, #669DF1)",
    GREEN: "var(--ds-background-accent-green-subtle, #4BCE97)",
    YELLOW: "var(--ds-background-accent-yellow-subtle, #EED12B)",
    RED: "var(--ds-background-accent-red-subtle, #F87168)",
    PURPLE: "var(--ds-background-accent-purple-subtle, #C97CF4)",
    VERIFIED: "var(--ds-icon-accent-blue, #357DE8)"
};
const $1c48b1994652ad1b$export$c70dda424cd479ac = {
    BLUE: "var(--ds-background-accent-blue-subtlest, #E9F2FE)",
    GREEN: "var(--ds-background-accent-green-subtlest, #DCFFF1)",
    YELLOW: "var(--ds-background-accent-yellow-subtlest, #FEF7C8)",
    RED: "var(--ds-background-accent-red-subtlest, #FFECEB)",
    PURPLE: "var(--ds-background-accent-purple-subtlest, #F8EEFE)"
};
const $1c48b1994652ad1b$export$8380141af31d7b6a = {
    BLUE: "var(--ds-background-accent-blue-subtlest-hovered, #CFE1FD)",
    GREEN: "var(--ds-background-accent-green-subtlest-hovered, #BAF3DB)",
    YELLOW: "var(--ds-background-accent-yellow-subtlest-hovered, #F5E989)",
    RED: "var(--ds-background-accent-red-subtlest-hovered, #FFD5D2)",
    PURPLE: "var(--ds-background-accent-purple-subtlest-hovered, #EED7FC)"
};
const $1c48b1994652ad1b$export$e755b4518de49373 = {
    BLUE: 'blue',
    GREEN: 'green',
    YELLOW: 'yellow',
    RED: 'red',
    PURPLE: 'purple'
};
module.exports["PRIMARY_COLORS"] = $1c48b1994652ad1b$export$af156f0af92331bd;
module.exports["SECONDARY_COLORS"] = $1c48b1994652ad1b$export$c70dda424cd479ac;
module.exports["HOVER_COLORS"] = $1c48b1994652ad1b$export$8380141af31d7b6a;
module.exports["COLOR_NAMES"] = $1c48b1994652ad1b$export$e755b4518de49373;

});

parcelRegister("8miSe", function(module, exports) {
/* eslint-disable check-file/filename-blocklist */ 
var $6fnsQ = parcelRequire("6fnsQ");


var $Uu0Pb = parcelRequire("Uu0Pb");

const $38122f14841a6560$export$b3a997d9e0eb41e = (color)=>{
    switch(color){
        case (0, $Uu0Pb.PRIMARY_COLORS).BLUE:
            return 0, $6fnsQ.B200;
        case (0, $Uu0Pb.PRIMARY_COLORS).GREEN:
            return 0, $6fnsQ.G200;
        case (0, $Uu0Pb.PRIMARY_COLORS).YELLOW:
            return 0, $6fnsQ.Y200;
        case (0, $Uu0Pb.PRIMARY_COLORS).PURPLE:
            return 0, $6fnsQ.P200;
        case (0, $Uu0Pb.PRIMARY_COLORS).RED:
            return 0, $6fnsQ.R200;
        default:
            return 0, $6fnsQ.B200;
    }
};
const $38122f14841a6560$export$979ed8c2392c1cb4 = (color)=>{
    const upperCaseColor = color?.toUpperCase(); // need toUpper since color we get from BE is lowercase
    switch(upperCaseColor){
        case 0, $6fnsQ.B200:
            return (0, $Uu0Pb.PRIMARY_COLORS).BLUE;
        case 0, $6fnsQ.G200:
            return (0, $Uu0Pb.PRIMARY_COLORS).GREEN;
        case 0, $6fnsQ.Y200:
            return (0, $Uu0Pb.PRIMARY_COLORS).YELLOW;
        case 0, $6fnsQ.P200:
            return (0, $Uu0Pb.PRIMARY_COLORS).PURPLE;
        case 0, $6fnsQ.R200:
            return (0, $Uu0Pb.PRIMARY_COLORS).RED;
        default:
            return color;
    }
};
function $38122f14841a6560$export$4407ed99ceb09a2c(colorCode) {
    const upperCaseColorCode = colorCode?.toUpperCase();
    switch(upperCaseColorCode){
        case (0, $Uu0Pb.PRIMARY_COLORS).BLUE.toUpperCase():
            return (0, $Uu0Pb.COLOR_NAMES).BLUE;
        case (0, $Uu0Pb.PRIMARY_COLORS).GREEN.toUpperCase():
            return (0, $Uu0Pb.COLOR_NAMES).GREEN;
        case (0, $Uu0Pb.PRIMARY_COLORS).YELLOW.toUpperCase():
            return (0, $Uu0Pb.COLOR_NAMES).YELLOW;
        case (0, $Uu0Pb.PRIMARY_COLORS).RED.toUpperCase():
            return (0, $Uu0Pb.COLOR_NAMES).RED;
        case (0, $Uu0Pb.PRIMARY_COLORS).PURPLE.toUpperCase():
            return (0, $Uu0Pb.COLOR_NAMES).PURPLE;
        default:
            return (0, $Uu0Pb.COLOR_NAMES).BLUE;
    }
}
module.exports["tokenToHex"] = $38122f14841a6560$export$b3a997d9e0eb41e;
module.exports["hexToToken"] = $38122f14841a6560$export$979ed8c2392c1cb4;
module.exports["colorCodeToColorName"] = $38122f14841a6560$export$4407ed99ceb09a2c;

});

parcelRegister("3lWl0", function(module, exports) {
/**
 * @generated SignedSource<<1fc101d910bfadb2619a1fc2d260f5a7>>
 * @relayHash a709390c581a22540e729216746ca889
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a90c8a354e986913f279369cfa4d048ae0d56c417c3d0ac292b15666f329274a
const $34dd87dd4e33f987$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isDraft"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "kind": "ScalarField",
        "name": "name"
    }, v3 = {
        "kind": "ScalarField",
        "name": "color"
    }, v4 = {
        "kind": "ScalarField",
        "name": "restrictionLevel"
    }, v5 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "isDraft",
                            "variableName": "isDraft"
                        }
                    ],
                    "concreteType": "ContentState",
                    "kind": "LinkedField",
                    "name": "contentState",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ ,
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "isCallerPermitted"
                        }
                    ]
                },
                {
                    "condition": "isDraft",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "format",
                                    "value": "USER_FRIENDLY"
                                }
                            ],
                            "concreteType": "ConfluenceDate",
                            "kind": "LinkedField",
                            "name": "contentStateLastUpdated",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                }
                            ],
                            "storageKey": "contentStateLastUpdated(format:\"USER_FRIENDLY\")"
                        }
                    ]
                }
            ]
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "AvailableContentStates",
            "kind": "LinkedField",
            "name": "availableContentStates",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ContentState",
                    "kind": "LinkedField",
                    "name": "customContentStates",
                    "plural": true,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v1 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ContentState",
                    "kind": "LinkedField",
                    "name": "spaceContentStates",
                    "plural": true,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v1 /*: any*/ ,
                        v4 /*: any*/ 
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "EditorContentStateQuery",
            "selections": v5 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "EditorContentStateQuery",
            "selections": v5 /*: any*/ 
        },
        "params": {
            "cacheID": "a709390c581a22540e729216746ca889",
            "id": "a90c8a354e986913f279369cfa4d048ae0d56c417c3d0ac292b15666f329274a",
            "metadata": {},
            "name": "EditorContentStateQuery",
            "operationKind": "query",
            "text": "query EditorContentStateQuery($contentId:ID!,$isDraft:Boolean!){singleContent(id:$contentId){id,contentState(isDraft:$isDraft){id,name,color,restrictionLevel,isCallerPermitted},contentStateLastUpdated(format:USER_FRIENDLY)@skip(if:$isDraft){value}},availableContentStates(contentId:$contentId){customContentStates{name,color,id},spaceContentStates{name,color,id,restrictionLevel}}}"
        }
    };
}();
$34dd87dd4e33f987$var$node.hash = "6fa3f178648bfd26c6dbf7026f2328a3";
var $34dd87dd4e33f987$export$2e2bcd8739ae039 = $34dd87dd4e33f987$var$node;
module.exports["default"] = $34dd87dd4e33f987$export$2e2bcd8739ae039;

});

parcelRegister("iNJwL", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $d22b8e53da9786d0$export$795eadcf91da84fd = (0, $cgtv4.defineMessages)({
    maxLength: {
        id: "content-state.status.create.status.max.length",
        defaultMessage: "Max length of 20"
    },
    requiredErrorMessage: {
        id: "content-state.status.maker.error.message",
        defaultMessage: "Required"
    },
    emptyStatusFlagTitle: {
        id: "content-state.status.empty.status.flag.title",
        defaultMessage: "Your status can\u2019t be saved"
    },
    emptyStatusFlagDescription: {
        id: "content-state.status.empty.status.flag.description",
        defaultMessage: "Statuses must contain symbols or alphanumeric characters."
    },
    verifiedRestricted: {
        id: "content-state.verified-restricted",
        defaultMessage: "This content is verified. Only its owner or an admin can change its status."
    },
    pageStatus: {
        id: "content-state.page-status",
        defaultMessage: "Status"
    }
});
module.exports["sharedi18n"] = $d22b8e53da9786d0$export$795eadcf91da84fd;

});

parcelRegister("4S6vT", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $6fnsQ = parcelRequire("6fnsQ");


var $Uu0Pb = parcelRequire("Uu0Pb");


var $8miSe = parcelRequire("8miSe");

const $87c020c14703301f$var$ContentStateColorSizes = {
    pageHistoryContentState: {
        ColorContainerStyles: (0, $ecnYn.xcss)({
            height: '10px',
            width: '10px',
            marginTop: 'space.0',
            marginBottom: 'space.0',
            marginLeft: 'space.050',
            marginRight: 'space.050'
        }),
        PlainContentStateColorStyles: (0, $ecnYn.xcss)({
            borderRadius: 'radius.full',
            width: '10px',
            height: '10px'
        }),
        scale: 'scale(0.625)',
        viewbox: '0 0 10px 10px'
    },
    rendererContentState: {
        ColorContainerStyles: (0, $ecnYn.xcss)({
            height: '12px',
            width: '12px',
            marginTop: 'space.0',
            marginBottom: 'space.0',
            marginRight: 'space.100',
            marginLeft: 'space.100'
        }),
        PlainContentStateColorStyles: (0, $ecnYn.xcss)({
            borderRadius: 'radius.xlarge',
            width: '12px',
            height: '12px'
        }),
        scale: 'scale(0.75)',
        viewbox: '0 0 12px 12px'
    },
    editorContentState: {
        ColorContainerStyles: (0, $ecnYn.xcss)({
            height: '16px',
            width: '16px',
            marginTop: 'space.0',
            marginBottom: 'space.0',
            marginLeft: 'space.400',
            marginRight: 'space.400'
        }),
        PlainContentStateColorStyles: (0, $ecnYn.xcss)({
            borderRadius: 'radius.full',
            width: '16px',
            height: '16px'
        }),
        scale: 'scale(1)',
        viewbox: '0 0 16px 16px'
    },
    contentStateButton: {
        ColorContainerStyles: (0, $ecnYn.xcss)({
            height: '12px',
            width: '12px',
            marginRight: 'space.050'
        }),
        PlainContentStateColorStyles: (0, $ecnYn.xcss)({
            borderRadius: 'radius.xlarge',
            width: '12px',
            height: '12px'
        }),
        scale: 'scale(0.75)',
        viewbox: '0 0 12px 12px'
    },
    spaceAdminContentState: {
        ColorContainerStyles: (0, $ecnYn.xcss)({
            maxHeight: '16px',
            maxWidth: '16px',
            marginRight: 'space.200'
        }),
        PlainContentStateColorStyles: (0, $ecnYn.xcss)({
            borderRadius: 'radius.full',
            width: '16px',
            height: '16px'
        }),
        scale: 'scale(1)',
        viewbox: '0 0 16px 16px'
    },
    restoreContentStatesModal: {
        ColorContainerStyles: (0, $ecnYn.xcss)({
            maxHeight: '16px',
            maxWidth: '16px'
        }),
        PlainContentStateColorStyles: (0, $ecnYn.xcss)({
            borderRadius: 'radius.full',
            width: '16px',
            height: '16px'
        }),
        scale: 'scale(1)',
        viewbox: '0 0 16px 16px'
    },
    subtleContentStateButton: {
        ColorContainerStyles: (0, $ecnYn.xcss)({
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '24px',
            width: '24px',
            marginRight: 'space.negative.025'
        }),
        PlainContentStateColorStyles: (0, $ecnYn.xcss)({
            borderRadius: 'radius.full',
            width: '10px',
            height: '10px'
        })
    },
    subtleRendererContentState: {
        ColorContainerStyles: (0, $ecnYn.xcss)({
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '24px',
            width: '24px'
        }),
        PlainContentStateColorStyles: (0, $ecnYn.xcss)({
            borderRadius: 'radius.full',
            width: '10px',
            height: '10px'
        })
    }
};
// The SVG defaults to 16x16
// We need to scale to different sizes
const $87c020c14703301f$var$CheckCircleSvg = (color, dataTestId, scale, viewbox)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "100%",
        height: "100%",
        viewBox: viewbox,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            display: 'block'
        },
        "data-testid": dataTestId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        transform: scale
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.62505 0.990813C8.94443 -0.330271 7.05558 -0.330271 6.37496 0.990813C5.96598 1.78463 5.04334 2.1668 4.19284 1.89468C2.77742 1.4418 1.4418 2.77742 1.89468 4.19284C2.1668 5.04334 1.78463 5.96598 0.990813 6.37496C-0.330271 7.05558 -0.330271 8.94443 0.990813 9.62505C1.78463 10.034 2.1668 10.9567 1.89468 11.8072C1.4418 13.2226 2.77742 14.5582 4.19284 14.1053C5.04334 13.8332 5.96598 14.2154 6.37496 15.0092C7.05558 16.3303 8.94443 16.3303 9.62505 15.0092C10.034 14.2154 10.9567 13.8332 11.8072 14.1053C13.2226 14.5582 14.5582 13.2226 14.1053 11.8072C13.8332 10.9567 14.2154 10.034 15.0092 9.62505C16.3303 8.94443 16.3303 7.05558 15.0092 6.37496C14.2154 5.96598 13.8332 5.04334 14.1053 4.19284C14.5582 2.77742 13.2226 1.4418 11.8072 1.89468C10.9567 2.1668 10.034 1.78463 9.62505 0.990813ZM11.2176 5.5246L11.2951 5.59368C11.6175 5.91602 11.6405 6.42433 11.3642 6.77323L11.2951 6.85076L7.73956 10.4063C7.41722 10.7287 6.90894 10.7517 6.56003 10.4754L6.48251 10.4063L4.70473 8.62854C4.3576 8.28141 4.3576 7.71859 4.70473 7.37146C5.02707 7.04912 5.53535 7.02609 5.88425 7.30238L5.96178 7.37146L7.11117 8.52029L10.0381 5.59368C10.3604 5.27134 10.8687 5.24831 11.2176 5.5246Z",
        fill: color
    })));
const $87c020c14703301f$var$getDisplayedColor = (color, isWarning)=>{
    if (isWarning) // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    return Boolean(undefined) ? (0, $6fnsQ.R200) : (0, $Uu0Pb.PRIMARY_COLORS).RED;
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    return Boolean(undefined) ? color : (0, $8miSe.hexToToken)(color);
};
const $87c020c14703301f$export$5ac2229016dfa3b6 = ({ color: color, restrictionLevel: restrictionLevel = 'NONE', appearance: appearance, isWarning: isWarning = false, dataTestId: dataTestId })=>{
    const { ColorContainerStyles: ColorContainerStyles, viewbox: viewbox, PlainContentStateColorStyles: PlainContentStateColorStyles, scale: scale } = $87c020c14703301f$var$ContentStateColorSizes[appearance];
    const displayedColor = $87c020c14703301f$var$getDisplayedColor(color ?? (0, $6fnsQ.B200), isWarning);
    const isRestrictedState = restrictionLevel !== 'NONE' && !isWarning;
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: ColorContainerStyles
    }, isRestrictedState ? $87c020c14703301f$var$CheckCircleSvg(displayedColor, dataTestId, scale, viewbox) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        testId: dataTestId,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        xcss: PlainContentStateColorStyles,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: {
            backgroundColor: displayedColor,
            scale: scale
        }
    })));
};
module.exports["ContentStateColor"] = $87c020c14703301f$export$5ac2229016dfa3b6;

});

parcelRegister("3qCob", function(module, exports) {
/* eslint-disable check-file/filename-blocklist */ 
var $Uu0Pb = parcelRequire("Uu0Pb");


var $8miSe = parcelRequire("8miSe");

const $41e22d3f43a50651$var$MAX_ALLOWED_CUSTOM_STATES = 3;
function $41e22d3f43a50651$export$86566dc9e85acb0c(primaryColor) {
    const tokenPrimaryColor = (0, $8miSe.hexToToken)(primaryColor ?? (0, $Uu0Pb.PRIMARY_COLORS).BLUE);
    switch(tokenPrimaryColor){
        case (0, $Uu0Pb.PRIMARY_COLORS).BLUE:
            return (0, $Uu0Pb.SECONDARY_COLORS).BLUE;
        case (0, $Uu0Pb.PRIMARY_COLORS).GREEN:
            return (0, $Uu0Pb.SECONDARY_COLORS).GREEN;
        case (0, $Uu0Pb.PRIMARY_COLORS).YELLOW:
            return (0, $Uu0Pb.SECONDARY_COLORS).YELLOW;
        case (0, $Uu0Pb.PRIMARY_COLORS).RED:
            return (0, $Uu0Pb.SECONDARY_COLORS).RED;
        case (0, $Uu0Pb.PRIMARY_COLORS).PURPLE:
            return (0, $Uu0Pb.SECONDARY_COLORS).PURPLE;
        default:
            return (0, $Uu0Pb.SECONDARY_COLORS).BLUE;
    }
}
function $41e22d3f43a50651$export$6844ce2c0353a555(secondaryColor) {
    const tokenSecondaryColor = (0, $8miSe.hexToToken)(secondaryColor ?? (0, $Uu0Pb.SECONDARY_COLORS).BLUE);
    switch(tokenSecondaryColor){
        case (0, $Uu0Pb.SECONDARY_COLORS).BLUE:
            return (0, $Uu0Pb.HOVER_COLORS).BLUE;
        case (0, $Uu0Pb.SECONDARY_COLORS).GREEN:
            return (0, $Uu0Pb.HOVER_COLORS).GREEN;
        case (0, $Uu0Pb.SECONDARY_COLORS).YELLOW:
            return (0, $Uu0Pb.HOVER_COLORS).YELLOW;
        case (0, $Uu0Pb.SECONDARY_COLORS).RED:
            return (0, $Uu0Pb.HOVER_COLORS).RED;
        case (0, $Uu0Pb.SECONDARY_COLORS).PURPLE:
            return (0, $Uu0Pb.HOVER_COLORS).PURPLE;
        default:
            return (0, $Uu0Pb.HOVER_COLORS).BLUE;
    }
}
function $41e22d3f43a50651$export$ccc9fe24e363c71e(oldContentState, newContentState) {
    if (!oldContentState) return false; // can't be duplicate if we don't even have a content state originally
    return oldContentState.name === newContentState.name && oldContentState.color === newContentState.color;
}
function $41e22d3f43a50651$export$a2f9d64eff18382c(customStatesArray, newCustomState) {
    for(let i = 0; i < customStatesArray.length; ++i){
        if ($41e22d3f43a50651$export$ccc9fe24e363c71e(customStatesArray[i], newCustomState)) return {
            index: i,
            id: customStatesArray[i]?.id
        };
    }
    // if we don't find a match just return null
    return null;
}
function $41e22d3f43a50651$export$cd8fa131e8c8f91e(oldCustomStatesArray, newCustomState) {
    /* Need to check if the state user entered matches an existing custom one in the array.
  If it's a duplicate, it means the state the user just typed in is one that already exists. We must find the index
  and id in the old array and handle it like if an existing custom state was selected
   */ const idAndIndex = $41e22d3f43a50651$export$a2f9d64eff18382c(oldCustomStatesArray, newCustomState);
    if (idAndIndex) // user typed in an existing custom state
    return $41e22d3f43a50651$export$1c741d2b42a2932b(oldCustomStatesArray, {
        ...newCustomState,
        id: idAndIndex.id
    }, idAndIndex.index);
    else {
        const newArray = [
            newCustomState,
            ...oldCustomStatesArray
        ];
        if (newArray.length > $41e22d3f43a50651$var$MAX_ALLOWED_CUSTOM_STATES) newArray.pop();
        return newArray;
    }
}
function $41e22d3f43a50651$export$1c741d2b42a2932b(oldCustomStatesArray, selectedCustomState, index) {
    // removed the selected custom state by index and then add it to the top of the new array
    const newArray = [
        ...oldCustomStatesArray
    ];
    newArray.splice(index, 1);
    newArray.unshift(selectedCustomState);
    return newArray;
}
module.exports["determineSecondaryColor"] = $41e22d3f43a50651$export$86566dc9e85acb0c;
module.exports["determineHoverColor"] = $41e22d3f43a50651$export$6844ce2c0353a555;
module.exports["isDuplicate"] = $41e22d3f43a50651$export$ccc9fe24e363c71e;
module.exports["createNewCustomStatesArrayWhenNewCustomAdded"] = $41e22d3f43a50651$export$cd8fa131e8c8f91e;
module.exports["createNewCustomStatesArrayWhenExistingCustomSelected"] = $41e22d3f43a50651$export$1c741d2b42a2932b;

});

parcelRegister("3hoG4", function(module, exports) {
$parcel$export(module.exports, "default", () => $b38c95e6dd3d3e2d$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

var /**
 * An alias for `forwardRef` with enhanced typing to preserve generic prop types.
 */ $b38c95e6dd3d3e2d$export$2e2bcd8739ae039 = (0, $42omo.forwardRef);

});


//# sourceMappingURL=EditorContentStateComponent.3351d36c.js.map
